import React, { forwardRef, useMemo , useCallback, useState } from 'react'
import { FieldTypes, urlRegexValidator } from 'utils/formUtils';
import CheckmarxOneMappingForm from './CheckmarxOneMappingForm';
import GenericPullCredentialsForm from '../GenericPullCredentialsForm';
import { useFeatureFlag } from "contexts/FeatureFlagContext";

function CheckmarxOneCredentialForm(props, ref) {
    const featureFlags = useFeatureFlag();
    const [tenantType, setTanantType] = useState(props.config?.tenantType ? props.config.tenantType: 'multi');

    const handleTenantType = useCallback((value)=> {
        setTanantType(value)
    },[]);

    const fields = useMemo(() => (
        [{
            name: "tenantName",
            label: "Tenant Name",
            required: true,
            type: FieldTypes.ANTD_DEFAULT_INPUT
        }, 
        {
            name: "tenantType",
            label: "Tenant Type",
            required: true,
            type: FieldTypes.SELECT,
            options: [
                {label: "Multi", value: "multi"},
                {label: "Single", value: "single"}
            ],
            props: {
                onChange: handleTenantType
            },
        },
        ...(tenantType === 'multi'
        ?
         [{
            name: "region",
            label: "Region",
            required: true,
            type: FieldTypes.SELECT,
            options: [{label: "US", value: "us" },{label: "US2", value: "us2" }, {label: "EU", value: "eu" }, {label: "ANZ", value: "anz" }, {label: "IND", value: "ind" }, {label: "SNG", value: "sng" }, {label: "EU2", value: "eu2" }, {label: "DEU", value: "deu" }, {label: "MEA", value: "mea" }]
        }]: []),
            {
            name: "apiEndpoint",
            label: "API Endpoint",
            required: true,
            rules:[urlRegexValidator],
        }, {
            name: "token",
            label: "Token",
            required: true,
            type: FieldTypes.PASSWORD,
        }, ...(featureFlags.MANAGE_SBOM ? [{
            name: "ingestSBOM",
            label: "Ingest Components",
            type: FieldTypes.SWITCH,
            help: 'Ingest all components from the projects mapped under this configuration into the Supply Chain module',
            inline: true,
          }] : []),]
    ),[featureFlags.MANAGE_SBOM, handleTenantType, tenantType])

    const beforeSave = useCallback((data) => {
        return {
            ...data,
            ...(tenantType === 'single' && { region : 'us'})
        }
    },[tenantType])

    const parseExtraFields = useCallback((config) => {
        return {
            ...config,
            ingestSBOM : config.ingestSBOM === "true" ? true : false
        };
    }, [])

    return (
        <GenericPullCredentialsForm
            {...props}
            ref={ref}
            fields={fields}
            MappingForm={CheckmarxOneMappingForm}
            initialValue={{tenantType: "multi", apiEndpoint: 'https://ast.checkmarx.net', ingestSBOM: false}}
            beforeSave={beforeSave}
            parseExtraFields={parseExtraFields}
        />
    )
}

export default forwardRef(CheckmarxOneCredentialForm);